const selectPublic = {
  // 品牌列表
  brandHeadList: {
    'CCW001': 'WEY',
    'CCH001': '哈弗',
    'CCO001': '欧拉',
    'CCP001': '长城皮卡',
    'CCZ001': '综合',
  },
  appIds: {
    'CCW001': 2,
    'CCH001': 1,
    'CCO001': 3,
    'CCP001': 5,
    'CCZ001': 0,
  },
  // 企业列表
  enterpriseHeadList: {
    'CC01': '长城',
    'XDZN': '仙豆',
  },
  // 品牌转换 // 使用场景（例如：商城中心）
  brandSwitchList: {
    'CCW001': 'CCW001',
    'CCH001': 'CCH001',
    'CCO001': 'CCO001',
    'CCP001': 'CCP001',
    'CCZ001': 'CCZ001,CCW001,CCH001,CCO001,CCP001',
  },
  // 企业转换  // 使用场景（例如：商城中心）
  enterpriseSwitchList: {
    'CC01': 'CC01',
    'XDZN': 'XDZN,CC01',
  },
  //新能源
  newEnergy: [
    { name: "车载终端本地存储时间周期", code: "localStorageTimeCycleOfVehicleTerminal" },
    { name: "正常信息上报时间周期", code: "informationReportingCycle" },
    { name: "报警信息上报时间周期", code: "alarmInformationReportingCycle" },
    { name: "远程服务与管理平台域名长度", code: "remoteServiceManagementPlatformHostLength" },
    { name: "远程服务与管理平台域名", code: "remoteServiceManagementPlatformHost" },
    { name: "远程服务与管理平台端口", code: "remoteServiceManagementPlatformPort" },
    { name: "硬件版本", code: "hardwareVersion" },
    { name: "固件版本", code: "softwareVersion" },
    { name: "车载终端心跳发送方周期", code: "heartbeatSendingCycle" },
    { name: "终端应答超时时间", code: "tboxResponseTimeOut" },
    { name: "平台应答超时时间", code: "tspResponseTimeOut" },
    { name: "登入失败后登入间隔时间", code: "loginTimeInterval" },
    { name: "公共平台域名长度", code: "commonPlatformHostLength" },
    { name: "公共平台域名", code: "commonPlatformHost" },
    { name: "公共平台端口", code: "commonPlatformPort" },
    { name: "是否处于抽样检测", code: "underSamplingMonitoring" },
  ],


  // HU日志管理(异常)
  anomalyType:[{code:'0',name:'crash'},{code:'1',name:'anr'}],
  HUstatus:[{code:'0',name:'未修复'},{code:'1',name:'已修复'},{code:'2',name:'已忽略'},{code: '3',name: '待验证'}],
  // 支付交易状态
  orderStatus: [{ name: '待支付', code: 'PAY_INIT' }, { name: '支付成功', code: 'PAY_SUCC' }, { name: '支付失败', code: 'PAY_FAIL' }, { name: '支付关闭', code: 'PAY_CLOSE' }, { name: '待退款', code: 'REFUND_INIT' }, { name: '退款处理中', code: 'REFUND_ING' }, { name: '退款成功', code: 'REFUND_SUCC' }, { name: '退款失败', code: 'REFUND_FAIL' }, { name: '退款关闭', code: 'REFUND_CLOSE' },],
  //车主中心
  vhicleOwnerType: [{ name: '全部', code: 'ALL' }, { name: '个人', code: 'PER' }, { name: '企业', code: 'COM' },],  // 客户类型
  vhicleOwnerStatus: [{ name: '全部', code: 'ALL' }, { name: '有效', code: 'yes' }, { name: '无效', code: 'no' },], // 车主车辆绑定状态
  vhicleOwnerRole: [{ name: '全部', code: 'ALL' }, { name: '车主', code: 'yes' }, { name: '使用者', code: 'no' },], // 车主车辆绑定变更用户角色
  vhicleOwnerIDtype: [{ name: '身份证', code: 'ID' }, { name: '企业统一社会信用代码', code: 'yes' }, { name: '其他', code: 'no' },],  // 新购车辆证件类型
  // 场景险
  weatherList: [
    {
      title: '睛',
      children: [{ english: 'Sunny/Clear', chinese: '晴', code: '100' }, { english: 'Cloudy', chinese: '多云', code: '101' }, { english: 'Few Clouds', chinese: '少云', code: '102' }, { english: 'Partly Cloudy', chinese: '晴间多云', code: '103' }, { english: 'Overcast', chinese: '阴', code: '104' },],
    },
    {
      title: '风',
      children: [{ english: 'Windy', chinese: '有风', code: '200' }, { english: 'Calm', chinese: '平静', code: '201' }, { english: 'Light Breeze', chinese: '微风', code: '202' }, { english: 'Moderate/Gentle Breeze', chinese: '和风', code: '203' }, { english: 'Fresh Breeze', chinese: '清风', code: '204' }, { english: 'Strong Breeze', chinese: '强风/劲风', code: '205' }, { english: 'High Wind, Near Gale', chinese: '疾风', code: '206' }, { english: 'Gale', chinese: '大风', code: '207' }, { english: 'Strong Gale', chinese: '烈风', code: '208' }, { english: 'Storm', chinese: '风暴', code: '209' }, { english: 'Violent Storm', chinese: '狂爆风', code: '210' }, { english: 'Hurricane', chinese: '飓风', code: '211' }, { english: 'Tornado', chinese: '龙卷风', code: '212' }, { english: 'Tropical Storm', chinese: '热带风暴', code: '213' },],
    },
    {
      title: '雨',
      children: [{ english: 'Shower Rain', chinese: '阵雨', code: '300' }, { english: 'Heavy Shower Rain', chinese: '强阵雨', code: '301' }, { english: 'Thundershower', chinese: '雷阵雨', code: '302' }, { english: 'Heavy Thunderstorm', chinese: '强雷阵雨', code: '303' }, { english: 'Thundershower with hail', chinese: '雷阵雨伴有冰雹', code: '304' }, { english: 'Light Rain', chinese: '小雨', code: '305' }, { english: 'Moderate Rain', chinese: '中雨', code: '306' }, { english: 'Heavy Rain', chinese: '大雨', code: '307' }, { english: 'Extreme Rain', chinese: '极端降雨', code: '308' }, { english: 'Drizzle Rain', chinese: '毛毛雨/细雨', code: '309' }, { english: 'Storm', chinese: '暴雨', code: '310' }, { english: 'Heavy Storm', chinese: '大暴雨', code: '311' }, { english: 'Heavy Storm', chinese: '特大暴雨', code: '312' }, { english: 'Freezing Rain', chinese: '冻雨', code: '313' }, { english: 'Light to moderate rain', chinese: '小到中雨', code: '314' }, { english: 'Moderate to heavy rain', chinese: '中到大雨', code: '315' }, { english: 'Heavy rain to storm', chinese: '大到暴雨', code: '316' }, { english: 'Storm to heavy storm', chinese: '暴雨到大暴雨', code: '317' }, { english: 'Heavy to severe storm', chinese: '大暴雨到特大暴雨', code: '318' }, { english: 'Rain', chinese: '雨', code: '399' }],
    },
    {
      title: '雪',
      children: [{ english: 'Light Snow', chinese: '小雪', code: '400' }, { english: 'Moderate Snow', chinese: '中雪', code: '401' }, { english: 'Heavy Snow', chinese: '大雪', code: '402' }, { english: 'Snowstorm', chinese: '暴雪', code: '403' }, { english: 'Sleet', chinese: '雨夹雪', code: '404' }, { english: 'Rain And Snow', chinese: '雨雪天气', code: '405' }, { english: 'Shower Snow', chinese: '阵雨夹雪', code: '406' }, { english: 'Snow Flurry', chinese: '阵雪', code: '407' }, { english: 'Light to moderate snow', chinese: '小到中雪', code: '408' }, { english: 'Moderate to heavy snow', chinese: '中到大雪', code: '409' }, { english: 'Heavy snow to snowstorm', chinese: '大到暴雪', code: '410' }, { english: 'Snow', chinese: '雪', code: '499' }],
    },
    {
      title: '雾',
      children: [{ english: 'Mist', chinese: '薄雾', code: '500' }, { english: 'Foggy', chinese: '雾', code: '501' }, { english: 'Haze', chinese: '霾', code: '502' }, { english: 'Sand', chinese: '扬沙', code: '503' }, { english: 'Dust', chinese: '浮尘', code: '504' }, { english: 'Duststorm', chinese: '沙尘暴', code: '507' }, { english: 'Sandstorm', chinese: '强沙尘暴', code: '508' }, { english: 'Dense fog', chinese: '浓雾', code: '509' }, { english: 'Strong fog', chinese: '强浓雾', code: '510' }, { english: 'Moderate haze', chinese: '中度霾', code: '511' }, { english: 'Heavy haze', chinese: '重度霾', code: '512' }, { english: 'Severe haze', chinese: '严重霾', code: '513' }, { english: 'Heavy fog', chinese: '大雾', code: '514' }, { english: 'Extra heavy fog', chinese: '特强浓雾', code: '515' },],
    },
    {
      title: '冷/热',
      children: [{ english: 'Hot', chinese: '热', code: '900' }, { english: 'Cold', chinese: '冷', code: '901' }, { english: 'Unknown', chinese: '未知', code: '999' },],
    }
  ], // 天气
  saleWayList: [{ name: '购买', code: '0' }, { name: '赠送', code: '1' },], // 售卖方式
  // 用户中心
  userTypeList:[{name:'全部', code:'ALL'},{name:'车主', code:'owner'},{name:'使用者', code:'user'},{name:'游客', code:'guest'},], // 用户角色
  // 常用
  ganderList: [{ name: '男', code: 'male' }, { name: '女', code: 'female' },],  // 性别
  redirectTypeList: [{ name: '无跳转', code: '0' }, { name: '跳转⾄App', code: '1' }, { name: '浏览器跳转H5链接', code: '2' }, { name: '应用内跳转', code: '3' }], //群发消息、运营卡片中的跳转类型
  openCloseList: [{ name: '开启', code: '0' }, { name: '关闭', code: '1' }], // 开启、关闭
  startusList: [{ name: '正常', code: 'N' }, { name: '关闭', code: 'C' }], // 状态
  startusOnList: [{ name: '停用', code: 0 }, { name: '启用', code: 1 }], // 状态
  sendModeList: [{ name: '审核通过后实时发送', code: 'by-review' }, { name: '定时发送', code: 'specified-time' }], // 发送方式
  userCheckTypeList: [{ name: '全部用户', code: '0' }, { name: '部分用户', code: '1' }], // 用户群体选择方式
  userChoiceTypeList: [{ name: '用户', code: '0' }, { name: '用户标签', code: '1' }, { name: '车辆', code: '2' }, { name: '车型标签', code: '3' },], // 选择用户维度
  // 运营卡片
  cardStatusList: [{ name: '启用', code: '1' }, { name: '禁用', code: '0' }], // 卡片激活状态
  cardshowTypeList: [{ name: '文本', code: 0 }, { name: '图片', code: 1 }, { name: '图片+文本', code: 2 },], // 卡片展示类型
  // 商家
  companyCardList: [{ name: '旧版营业执照（普通证照）', code: 1 }, { name: '三合一新版营业执照', code: 2 }], // 企业证件类型
  personCardTpeList: [{ name: '身份证', code: 1 }, { name: '护照', code: 2 }, { name: '军官证', code: 3 }, { name: '士兵证', code: 4 }, { name: '回乡证', code: 5 }, { name: '户口本', code: 6 }, { name: '警官证', code: 7 }, { name: '台胞证', code: 8 }, { name: '其它', code: 9 }], // 人证件类型
  settlementTypeList: [{ name: '销售价结算', code: 1 }, { name: '成本价结算', code: 2 }], // 结算类型
  agencyStatusList: [{ name: '已签约', code: '1' }, { name: '未签约', code: '0' },], // 商家签约状态
  payTypeList: [{ name: '扫码支付', code: '1' }, { name: 'APP支付', code: '2' }, { name: '手机网站支付', code: '3' },], // 商家支付配置
  payChannelList: [{ name: '支付宝直连', code: '1' }, { name: '汇付-支付宝', code: '2' }, { name: '微信支付直连', code: '3' }, { name: '汇付-微信支付', code: '4' }, { name: '杭银-支付宝', code: '5' }, { name: '杭银-微信支付', code: '6' },], // 商家支付配置渠道选择
  // 活动
  actStatusList: [{ name: '未开始', code: 'UNSTART' }, { name: '进行中', code: 'RUNNING' }, { name: '已结束', code: 'END' }], // 活动状态
  actExamineList: [{ name: '未审核', code: 'UNAUDIT' }, { name: '审核通过', code: 'SUCCESS' }, { name: '审核不通过', code: 'FAIL' }, { name: '举报下线', code: 'COMPLAINT_OFFLINE' }], // 活动审核状态
  actTypeList: [{ name: '概率抽奖', code: 'LUCK_DRAW_RATE' }, { name: '在线报名', code: 'SIGN_UP' }, { name: '征贴活动', code: 'COLLECT_ARTICLE' }, { name: '图文活动', code: 'IMAGE_TEXT' }], // 活动类型
  networkList: [{ name: 'wifi', code: 'WIFI' }, { name: '4g', code: 'FOUR_G' }], // 网络状态
  brandIdList: [{ name: "WEY", code: "CCW001" }, { name: "哈弗", code: "CCH001" }, { name: "欧拉", code: "CCO001" }, { name: "长城皮卡", code: "CCP001" }, { name: "综合", code: "CCZ001" }], // 品牌
  enterpriseIdList: [{ name: "长城", code: "CC01" }, { name: "仙豆", code: "XDZN" }], // 企业

  // 推荐策略管理
  RecommendChannel: [{ name: '手机', code: 'C_0' }, { name: '车机', code: 'C_1' }],  // 渠道
  Recommendbrand: [{ name: '哈弗', code: 'CCH001' }, { name: 'WEY', code: 'CCW001' }, { name: '欧拉', code: 'CC0001' },],  // 品牌

  //新用户中心
  NewState:[{ name:"有效",code:"1"},{ name:"失效",code:"0"},],
  NewUser:[{ name:"使用者", code:'2'},{ name:"车主", code:'1'},{ name:"游客", code:'3'},],
  NewCreate:{1:"vms实销同步",2:"运营平台录入新购车辆",3:"运营平台录入变更车主",4:"运营平台录入新增用户",5:"C端用户注册",},
  NewSource:{'autonavi':'高德','wecar':'腾讯车机','wechat':'微信','koudai':'口袋故事','ximalaya':'喜马拉雅','tingban':'听伴','Zhihu':'知乎','wecarOpen':'腾讯我的车开放平台',},
  // 车辆调试管理
  // 远控类型
  remoteType:{'0':'远控','1':'查询车况','2':'预约充电设置','3':'停止、恢复充电','4':'充电设置查询','5':'车辆远程追踪','6':'HU消息通知','7':'车载终端控制','9':'TBox远程日志',},
  remoteCommandList:{
    LOGIN: { id:1, code:"1001", name:"Tbox登录" },
    LOGOUT: { id:2, code:"1002", name:"Tbox登出" },
    HEARTBEAT: { id:3, code:"1004", name:"心跳" },
    IBE_CALL: { id:6, code:"2001", name:"I-B-E/Call上报" },
    STATUS: { id:7, code:"", name:"查询车况" },
    WARNING: { id:8, code:"3001", name:"车辆报警" },
    REMOTE_CONTROL_RESULT: { id:9, code:"3004", name:"远控结果上报" },
    FAULT: { id:11, code:"3006", name:"车辆故障" },
    GET_CONFIG_INFO: { id:4, code:"1005", name:"获取配置文件信息" },
    REPLACEMENT_INFO_UPLOAD: { id:5, code:"1006", name:"补发信息上报" },
    STATUS_CHANGE: { id:10, code:"3005", name:"车辆状态变更主动上报" },
    HUT_RESERVATION_CHARGING_SETTING_APP: { id:12, code:"3007", name:"HUT预约充电同步" },
    BIG_DATA_STATUS: { id:20, code:"3016", name:"车况大数据主动上报" },
    REMOTE_DIAGNOSTIC_DATA_UPLOAD: { id:19, code:"4006", name:"远程诊断数据主动上报" },
    STATUS_QUERY: { id:21, code:"3002", name:"车况查看" },
    REMOTE_CONTROL: { id:25, code:"3003", name:"远控指令下发" },
    REMOTE_CONTROL_START_OR_STOP_CHARGING: { id:27, code:"3011", name:"远程控制-停止/恢复充电" },
    REMOTE_TRACKING_DATA_UPLOAD: { id:15, code:"3014", name:"车辆远程追踪" },
    HU_MESSAGE_NOTIFICATION: { id:29, code:"4001", name:"HU消息通知" },
    VEHICLE_TERMINAL_CONTROL: { id:30, code:"4003", name:"车载终端控制" },
    SCHEDULE_THE_COMPLETION_TIME_OF_CHARGING: { id:13, code:"3008", name:"预约充电完成时间上报" },
    IMMEDIATE_CHARGE_NOTIFICATION: { id:14, code:"3009", name:"立即充电通知" },
    GET_ROOT_CERTIFICATE: { id:16, code:"4002", name:"获取根证书" },
    GB_SERVER_JOIN_RESULT: { id:17, code:"4004", name:"国标服务器连接结果上报" },
    HU_GET_WEATHER: { id:18, code:"4005", name:"HU获取天气" },
    GET_BIG_DATA_CONFIG_INFO: { id:22, code:"1007", name:"获取大数据信号采集策略配置" },
    STATUS_CHANGE_ONLINE: { id:23, code:"3015", name:"车辆状态变更主动上报: { id:在线时)" },
    BIG_DATA_ACQUISITION_CONFIGURATION_STRATEGY: { id:24, code:"3017", name:"大数据采集策略配置下发" },
    APP_RESERVATION_CHARGING_SETTING: { id:26, code:"3010", name:"APP预约充电设置" },
    CHARGING_SETTING_QUERY: { id:28, code:"3012", name:"充电设置查询" },
    OPEN_OR_CLOSE_TBOX_LOG: { id:31, code:"4007", name:"开启/关闭Tbox远程日志" },
    REMOTE_TBOX_NOTIFY: { id:32, code:"4008", name:"远程Tbox通知" },
    ERROR: { id:33, code:"", name:"错误指令" },
    EV_GB_DATA: { id:34, code:"", name:"国标数据" },
    GB_LOGIN: { id:35, code:"", name:"T5-国标登录" },
    GB_LOGOUT: { id:36, code:"", name:"T5-国标登出" },
    REMOTE_REQUEST: { id:37, code:"", name:"T5-远控请求" },
    ICALL_DATA_REPORT_DATA: { id:38, code:"", name:"T5-ICALL数据" },
    CAN_REPORT_DATA: { id:44, code:"", name:"T5-CAN数据" },
    DLT_REPORT_DATA: { id:45, code:"", name:"T5-DLT数据" },
    DTC_REPORT_DATA: { id:46, code:"", name:"T5-DTC数据" },
    VEHICLE_STATUS_DATA: { id:47, code:"", name:"T5-车况数据" },
    TBOX_MONITOR: { id:48, code:"", name:"T5-TBOX监测数据" },
    VEHICLE_REPAIR_DATA: { id:39, code:"", name:"T5-车辆维修数据" },
    SPECI_ALALARM_REPAIR_DATA: { id:40, code:"", name:"T5-特殊报警维修数据" },
    TRIGGER_CAN_DATA_REPORT: { id:41, code:"", name:"T5-触发式CAN数据" },
    EMERGENCY_DVRACTIVATION_REPORT: { id:42, code:"", name:"T5-紧急DVR" },
    CAN_FILE_CALIBRATION_FAILURE_REPORT: { id:43, code:"", name:"T5-CAN文件校验失败上报" },
  },  // 品牌

  // 商城类目管理
  categorySpecifications: { 0: '无规格', 1: '有规格', },

  // 声纹
  voicePrintUserType:[{code: 'model',name: '车型用户'},{code: 'vin',name: '车辆用户'}],
  voicePrintStateList:[{code: 'enable',name: '启用'},{code: 'disable',name: '禁用'}],


  // 网关协议配置
  signalDataList:{1:'网关数据', 2:'协议数据',3:'DLT数据'}, // 数据分类
  signalTypeList:['DTC','STATUS','VALUE','VALID'], // 信号类型
  DTCseverityLeverList:['0x00','0x20','0x40','0x80'], // DTC严重度
  DTCyesOrOn:{1:'yes',2:'no'},
  DTCCounterTypeList:{1:'Operation Cycle',2:'Driving Cycle',3:'Warming up Cycle'},
  // 配置文件维护 参数
  configurationFile: {
    configTypeList: {'tbox': 'TBOX配置','rtm': 'RTM配置',}, // 配置类型列表
    statusList: {false: '否',true: '是',}, // 状态列表
  },
  // 长城电商结算中心--字典库
  settlementCenter:{
    // 订单平台
    PLATFORM_CODE_LIST:[{name:'全部', code:'ALL'}, { code: "10797226", name: "天猫商城" }, { code: "10891697",name: "苏宁易购" },{code: '10893983', name: '京东商城'},{ code: "10905352_1",name: "哈弗商城"},{ code: "10905352_2",name: "WEY商城"},{ code: "10905352_3",name: "欧拉商城"},{ code: "10905352",name: "自有商城"}],
    // 结算状态
    SETTLEMENT_STATUS_LIST: [{ code: "SETTLED", name: "已结算已支付"},{ code: "SETTLE_FAILED", name: "已结算未支付"},{ code: "NOT_SETTLE",name: "未结算"}],
    // 订单状态
    ORDER_STATUS_LIST: [{ code: "ALL",name: "全部" },{ code: "WAIT_BUYER_PAY",name: "待付款" },{ code: "WAIT_SELLER_SEND_GOODS",name: "待发货" },{ code: "WAIT_BUYER_CONFIRM_GOODS", name: "待收货" },{ code: "TRADE_FINISHED", name: "交易成功" },{ code: "TRADE_CLOSED", name: "交易关闭" },{ code: "ORDER_CANCEL", name: "订单取消" }],
    // 支付渠道
    PAYMENT_CHANNEL: [{code: 'WE_CHAT', name: '微信'},{code: 'ALIPAY', name: '支付宝'}],
    // 商户类型
    AGENTTYPE_LIST:[ {code: 'SHOP', name: '4S店'},{code: 'CITY_SHOW_ROOM', name: '城市展厅'},{code: 'MONOMER_STATION', name: '单体站'},{code: 'LARGE_MAINTENANCE_CENTER', name: '大型维修中心'},{code: 'COOPERATIVE_SUPPLIER', name: '合作供应商'},{code: 'GW_MERCHANTS', name: '长城商户'}],
    // 见证宝开户状态
    AGENTSTATUS_LIST:[ {code: 'NOT_ACCOUNT_OPENING', name: '未开户'},{code: 'AGENT_UNBOUND_CARD', name: '已开户'},{code: 'AGENT_BIND_CARD', name: '已绑卡'}],
    // 商户状态
    MERCHANT_STATUS:[ {code: 'NORMAL', name: '正常'},{code: 'PAUSE', name: '暂停'},{code: 'EARLY_WARNING', name: '预警'},{code: 'RELEASE', name: '解约'}],
    // 可选择商户类型
    OPTIONAL_AGENTTYPE_LIST:[ {code: 'COOPERATIVE_SUPPLIER', name: '合作供应商'},{code: 'GW_MERCHANTS', name: '长城商户'}],
    // 是否平安银行
    BANKTYPE_LIST:[ {code: 'YES', name: '是'},{code: 'NO', name: '否'}],
    // 订单失败原因
    ORDERFAILED_STATUS:[ {code: 'NOT_FOUND_ORDER', name: '无法找到订单'},{code: 'REPEAT_ORDER', name: '订单已结算已支付'},{code: 'NOT_VERIFY', name: '订单未核销'},{code: 'ORDER_NOT_PAY', name: '订单已结算未支付'}],
    // 手动or自动账单
    SETTLEWAY_LIST:[{code: 'AUTO', name: '自动'},{code: 'MANUAL', name: '手动'}],
    // 证件类型
    MEMBER_GLOBAL_LIST: [{code: '73', name: '统一信用社码'},{code: '68', name: '营业执照'},{code: '1', name: '身份证'}]
  }
};
export default selectPublic;

